/**
 * Firebase client initialization.
 *
 * These values are the app's PUBLIC web config (the apiKey is a project
 * identifier, not a secret — it is meant to ship in client code). Auth is
 * gated by Firebase's authorized-domains + provider settings, not by hiding
 * this config.
 */
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyByQCSjWDXBZIAAmkY6msb9kGDNe2QcpBw',
  authDomain: 'new-data-dojo.firebaseapp.com',
  projectId: 'new-data-dojo',
  storageBucket: 'new-data-dojo.firebasestorage.app',
  messagingSenderId: '418903597938',
  appId: '1:418903597938:web:ccba8b03e281b3eeeef3eb',
  measurementId: 'G-MECGDQSNZ9',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

/** Stable per-user id used as the engine's `learner_id` (memory key). */
export function getLearnerId() {
  return auth.currentUser?.uid || 'anon';
}

/** Current user's Firebase ID token (JWT), or null if signed out.
 *  Cached by the SDK and auto-refreshed; safe to call per request. */
export async function getIdToken() {
  const user = auth.currentUser;
  if (!user) return null;
  try {
    return await user.getIdToken();
  } catch {
    return null;
  }
}
